import BaseApiService from '@/services/common/api/baseApiService';

class PurchaseOrderService extends BaseApiService {
  getPurchaseOrder(purchaseOrderNumber) {
    return this.httpClient.get(this.apiEndPointsBuilder.purchaseOrderDetails(purchaseOrderNumber));
  }

  getPurchaseOrderShippingInfo(purchaseOrderNumber) {
    return this.makeRequest(this.httpClient
      .get(this.apiEndPointsBuilder.purchaseOrderShippingInfo(purchaseOrderNumber)));
  }

  isPurchaseOrderExists(purchaseOrderNumber) {
    return this.makeRequest(this.httpClient
      .get(
        this.apiEndPointsBuilder.purchaseOrderDetailsExists(purchaseOrderNumber),
      ));
  }

  getPurchaseOrderFindResults(searchTextPONumberOrSku, pageNumber, pageSize) {
    return this.makeRequest(this.httpClient.get(this.apiRoutes.purchaseOrders, {
      params: {
        pageSize,
        pageNumber,
        q: searchTextPONumberOrSku,
      },
    }));
  }

  getPurchaseOrderLineItemUploadedImages(purchaseOrderNumber, lineItemId) {
    return this.makeRequest(this.httpClient
      .get(
        this.apiEndPointsBuilder
          .purchaseOrderLineItemUploadedImages(purchaseOrderNumber, lineItemId),
      ));
  }

  getPurchaseOrderLineItemApprovedImages(purchaseOrderNumber, lineItemId) {
    return this.makeRequest(this.httpClient
      .get(
        this.apiEndPointsBuilder
          .purchaseOrderLineItemApprovedImages(purchaseOrderNumber, lineItemId),
      ));
  }

  getPurchaseOrderLineItemActivity(purchaseOrderNumber, lineItemId) {
    return this.makeRequest(this.httpClient
      .get(
        this.apiEndPointsBuilder.purchaseOrderLineItemActivity(purchaseOrderNumber, lineItemId),
      ));
  }

  updatePoLineItemsStatus(purchaseOrderNumber, statusTransitionInfo) {
    return this.makeRequest(this.httpClient
      .put(
        this.apiEndPointsBuilder.poLineItemsStatusTransition(purchaseOrderNumber),
        statusTransitionInfo,
      ));
  }

  uploadLineItemImages(images, purchaseOrderNumber, sku, lineItemId) {
    const formData = new FormData();
    for (let i = 0; i < images.length; i += 1) {
      const file = images[i];

      formData.append('files', file);
    }

    return this.makeRequest(
      this.httpClient.post(
        this.apiEndPointsBuilder
          .uploadLineItemImages(purchaseOrderNumber, lineItemId, sku),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      ),
    );
  }

  uploadLineItemsImages(images, purchaseOrderNumber, lineItemIds) {
    const formData = new FormData();
    for (let i = 0; i < images.length; i += 1) {
      const file = images[i];

      formData.append('files', file);
    }

    for (let i = 0; i < lineItemIds.length; i += 1) {
      formData.append('lineItemIds[]', lineItemIds[i]);
    }

    return this.makeRequest(
      this.httpClient.post(
        this.apiEndPointsBuilder
          .uploadLineItemsImages(purchaseOrderNumber),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      ),
    );
  }

  getApprovalDocument(purchaseOrderNumber, lineItemIds) {
    return this.makeRequest(
      this.httpClient(
        this.apiEndPointsBuilder
          .getApprovalDocument(purchaseOrderNumber),
        {
          method: 'POST',
          data: lineItemIds,
          responseType: 'blob',
        },
      ),
    );
  }

  reportPoLineItemsIssue(purchaseOrderNumber, reportIssueInfo) {
    return this.makeRequest(this.httpClient
      .put(
        this.apiEndPointsBuilder.poLineItemsReportIssue(purchaseOrderNumber),
        reportIssueInfo,
      ));
  }

  addComments(purchaseOrderNumber, commentInfo) {
    return this.makeRequest(this.httpClient
      .put(
        this.apiEndPointsBuilder.poLineItemsComment(purchaseOrderNumber),
        commentInfo,
      ));
  }

  getCanAddComment(purchaseOrderNumber, lineItemId) {
    return this.makeRequest(this.httpClient
      .get(
        this.apiEndPointsBuilder
          .canAddComment(purchaseOrderNumber, lineItemId),
      ));
  }

  getMyPurchaseOrders(pagination) {
    const paginationData = pagination || {};
    return this.makeRequest(this.httpClient.get(this.apiRoutes.PurchaseOrdersMy, {
      params: {
        pageSize: paginationData.pageSize,
        pageNumber: paginationData.pageNumber,
        sortBy: paginationData.sortBy,
        sortOrder: paginationData.sortOrder,
        filterQuery: paginationData.filterQuery,
      },
    }))
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  deleteLineItemImage(imageId, purchaseOrderNumber, sku, lineItemId) {
    return this.makeRequest(
      this.httpClient
        .delete(this.apiEndPointsBuilder
          .deleteLineItemImage(purchaseOrderNumber, lineItemId, sku, imageId)),
    );
  }

  deleteLineItemImageMultiple(imageId, purchaseOrderNumber, lineItemIds) {
    return this.makeRequest(
      this.httpClient
        .put(
          this.apiEndPointsBuilder
            .deleteLineItemImageMultiple(purchaseOrderNumber),
          {
            imageId,
            lineItemIds,
          },
        ),
    );
  }

  deleteLineItemCommentMultiple(commentId, purchaseOrderNumber, lineItemIds) {
    return this.makeRequest(this.httpClient
      .put(
        this.apiEndPointsBuilder.deleteLineItemCommentMultiple(purchaseOrderNumber),
        {
          commentId,
          lineItemIds,
        },
      ));
  }
}

export default PurchaseOrderService;
